import i18n from 'i18next';
import React from 'react';

export default () => (
  <>
    <h1>{i18n.t('error404Title')}</h1>
    <p>{i18n.t('error404Description')}</p>
  </>
);
